export const DEFAULT_SALARY_PERIOD = 'annually';

export const salaryPeriodLabelMap: Record<string, string> = {
  hourly: 'Hourly',
  monthly: 'Monthly',
  annually: 'Annually',
};

export const salaryPeriodSuffixMap: Record<string, string> = {
  hourly: 'hour',
  monthly: 'month',
  annually: 'year',
};

export const salaryPeriodOptions = [
  { key: 'hourly', label: salaryPeriodLabelMap.hourly },
  { key: 'monthly', label: salaryPeriodLabelMap.monthly },
  { key: 'annually', label: salaryPeriodLabelMap.annually },
];
